<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    v-if="image || title"
    class="flex flex-col w-full py-6 mt-5 border-t border-b border-gray-300 border-solid md:flex-row md:justify-between md:grow-0"
  >
    <div v-if="title" class="md:w-1/2 md:pr-4">
      <h4 class="text-xs font-bold text-primary-900 md:text-sm">
        {{ title }}
      </h4>
      <div class="text-media__text" v-html="richTextToHtmlString(text.json, text.links)" />
    </div>
    <ContentfulImage class="rounded text-media__image md:w-1/2" :entry="image" :use-light-box="true" />
  </div>
</template>

<script setup lang="ts">
import gql from '@/gql/contentful';

type Props = {
  id: string;
};

const props = defineProps<Props>();

const { fetchEntryWithGraphQL } = useContentful();

const { data } = await useAsyncData(props.id, async () => {
  const { data, error } = await fetchEntryWithGraphQL(gql.getTextAndMedia, {
    id: props.id,
  });

  if (error) {
    return { data: null, error };
  }

  return { data, error: null };
});

const image = computed(() => (data.value as any).data.textAndMedia?.image);
const title = computed(() => (data.value as any).data.textAndMedia?.textMediaTitle);
const text = computed(() => (data.value as any).data.textAndMedia?.text);
</script>

<script lang="ts">
export default defineComponent({
  name: 'TextAndMedia',
});
</script>
